import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'paymethod',
  templateUrl: './paymethod.component.html',
  styleUrls: ['./paymethod.component.scss'],
})
export class PaymethodComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
